const prototype = {
  toRequest() {
    let toRequest = JSON.parse(JSON.stringify(this));

    delete toRequest.nome;
    delete toRequest.objEstado;
    delete toRequest.municipioSelecionado;
    delete toRequest.estadoId;
    delete toRequest.objMunicipio;

    return toRequest;
  }
};

export default function createFiltroInteligenciaTerritorial(filtro = {}) {
  const novoFiltro = Object.create(prototype);
  const data = Object.assign(novoFiltro, {
    cicloSafra: 1,
    tipoAgrupamento: 'PAIS',
    codigosCulturas: null,
    agruparPorCultura: false,
    idsMunicipios: [],
    siglaEstado: null,
    codigosCars: [],
    nome: null,
    possuiRestricao: null,
    areaImovelInicial: null,
    areaPlantadaInicial: null,
    areaPastagemInicial: null,
    estadoId: null,
    objEstado: null,
    municipioSelecionado: null,
    ...filtro
  });
  return data;
}
